import { connect } from "react-redux";
import { React, useState } from "react";
import { Actions as PENSIONACTIONS } from "../../store/actions/pensionActions";
import Select from "react-select";


export const AutoEnrolmentRow = ({
	employee,
	groupOptions,
	updateReassessmentEmployee,
}) => {

	return (
		<tr>
			<td>
				{employee?.fullName}
			</td>
			<td>
			<Select
				name="Group Options"
				options={groupOptions}
				// isDisabled={disabled}
				value={groupOptions.find((chosenGroup) => chosenGroup.value === employee?.groupId)}
				placeholder="Choose one"
				onChange={(e) => {
					updateReassessmentEmployee(employee.agreementId, e.value);
				}}
			/>
			</td>
            <td></td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {

	const groupOptions = state?.pensions?.group?.list?.map((group) => ({
		value: group.id,
		label: group.name,
	}));

	return {
		groupOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateReassessmentEmployee: (agreementId, groupId) => dispatch(PENSIONACTIONS.updateReassessmentEmployee(agreementId, groupId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoEnrolmentRow);
